import { options } from "pages/NurseOut/ExamHistory/config";
import { useState } from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COLOR, COMBO_BOX, TIME,NUMBER } = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields = (onChange?) => {
  const dataFields: DataFormField[] = [
    {
      type: COMBO_BOX,
      label: "Loại công việc",
      name: "loaiCaLam",
      disable: false,
      expand: false,
      options: [
        { value: 0, label: "Thực hiện chấm công" },
        { value: 1, label: "Không thực hiện chấm công" },
        { value: 2, label: "Ca linh hoạt thời gian" },
      ],
      onChange: onChange,
      rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Tên ca",
      name: "tenCa",
      hide:false,
      rules: [{ required: true, message: "Chưa nhập tên ca" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
      disable: false,
    },
    {
      type: TIME,
      label: "TG bắt đầu",
      name: "thoiGianBatDau",
      disable: false,
      hide:false,
      // rules: [{ required: true, message: "Chưa nhập thời gian bắt đầu" }],
      optionsTime: {
        showTime: true,
        format: FORMAT_TIME.time_24h,
      },
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: TIME,
      label: "TG tính giờ đi muộn",
      name: "thoiGianTinhGioDiMuon",
      disable: false,
      hide:false,
      // rules: [{ required: true, message: "Chưa nhập thời gian đi muộn" }],
      optionsTime: {
        showTime: true,
        format: FORMAT_TIME.time_24h,
      },
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: NUMBER,
      label: "Số giờ làm",
      hide:false,
      name: "soGioLam",
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: TIME,
      label: "TG kết thúc",
      name: "thoiGianKetThuc",
      // rules: [{ required: true, message: "Chưa nhập thời gian kết thúc" }],
      disable: false,
      optionsTime: {
        showTime: true,
        format: FORMAT_TIME.time_24h,
      },
      hide:false,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Ký hiệu ca",
      name: "kyHieuCa",
      hide:false,
      rules: [{ required: true, message: "Chưa nhập ký hiệu ca" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
      disable: false,
    },
    {
      type: COMBO_BOX,
      label: "Ký hiệu công tương ứng",
      name: "chamCongTuongUng",
      hide:false,
      options: [
        { value: "0", label: "0" },
        { value: "NP", label: "NP" },
        { value: "1/2P", label: "1/2P" },
        { value: "0.5P", label: "0.5P" },
        { value: "NB", label: "NB" },
        { value: "1/2B", label: "1/2B" },
        { value: "0.5B", label: "0.5B" },
        { value: "B/P", label: "B/P" },
        { value: "NL", label: "NL" },
        { value: "ÔC", label: "ÔC" },
        { value: "1/2ÔC", label: "1/2ÔC" },
        { value: "KL", label: "KL" },
        { value: "1", label: "1" },
        { value: "0.5", label: "0.5" },
        { value: "TS", label: "TS" },
        { value: "Ô", label: "Ô" },
        { value: "CĐ", label: "CĐ" },
        { value: "0.5ÔC", label: "0.5ÔC" },
        { value: "MT", label: "MT" },
        { value: "0.5NL", label: "0.5NL" },
        { value: "0.5MT", label: "0.5MT" },
        { value: "CÔ", label: "CÔ" },
        { value: "1/2CÔ", label: "1/2CÔ" },
        { value: "0.5CÔ", label: "0.5CÔ" },
        { value: "CT", label: "CT" },
        { value: "1/2CT", label: "1/2CT" },
        { value: "0.5CT", label: "0.5CT" },
      ],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: TIME,
      label: "TG vào làm từ",
      name: "thoiGianVaoLamTu",
      // rules: [{ required: true, message: "Chưa nhập thời gian kết thúc" }],
      disable: false,
      optionsTime: {
        showTime: true,
        format: FORMAT_TIME.time_24h,
      },
      hide:true,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: TIME,
      label: "TG vào làm đến",
      name: "thoiGianVaoLamDen",
      // rules: [{ required: true, message: "Chưa nhập thời gian kết thúc" }],
      disable: false,
      optionsTime: {
        showTime: true,
        format: FORMAT_TIME.time_24h,
      },
      hide:true,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
  ];
  return dataFields;
};
export { dataFields };
